import { render, staticRenderFns } from "./EditUserAccount.vue?vue&type=template&id=379b0de6&"
import script from "./EditUserAccount.vue?vue&type=script&lang=js&"
export * from "./EditUserAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports